export const SECOND_URL = process.env.SECOND_URL;
export const WEB_API_ORIGIN = process.env.WEB_API_ORIGIN;
export const CLOUD_URL = process.env.CLOUD_URL;
